import { assert } from '../env-utils/assert';
import { VERSION as __VERSION__ } from '../env-utils/version';
const NPM_TAG = 'latest';
const VERSION = typeof "3.0.12" !== 'undefined' ? "3.0.12" : NPM_TAG;
export function getWorkerName(worker) {
  const warning = worker.version !== VERSION ? ` (worker-utils@${VERSION})` : '';
  return `${worker.name}@${worker.version}${warning}`;
}
export function getWorkerURL(worker, options = {}) {
  const workerOptions = options[worker.id] || {};
  const workerFile = `${worker.id}-worker.js`;
  let url = workerOptions.workerUrl;

  if (options._workerType === 'test') {
    url = `modules/${worker.module}/dist/${workerFile}`;
  }

  if (!url) {
    let version = worker.version;

    if (version === 'latest') {
      version = NPM_TAG;
    }

    const versionTag = version ? `@${version}` : '';
    url = `https://unpkg.com/@loaders.gl/${worker.module}${versionTag}/dist/${workerFile}`;
  }

  assert(url);
  return url;
}
//# sourceMappingURL=get-worker-url.js.map